<template>
	
  <div class="home">

   <div class="home-ct">

<div class="login">
	<div class="address">
		<div class="re-tit">
				   <h4>接收資訊</h4>
		</div>
		<div class="re-con">
			<ul>
				<li v-for="item in news" :class="{'ord-cook':item.id==address_id}" @click="ordCase(item)">
					<div class="l1">
						<span>{{item.name}}</span><span v-if="item.if_default==1">默認地址</span>
					</div>
					<div class="l2">
						{{item.areaName}}
						{{item.address}}	
					</div>
					<div class="l3">
						<span>	{{item.phone}}</span>
					</div>
				</li>
			
				<router-link to="/user/address?ind=1"><li class="plus">
				<img src="../../assets/plus.png" />
				添加地址
				</li></router-link>
				<div class="clear"></div>
			</ul>
		</div>
	</div>





	<div class="login-r1">
	<div class="re-tit">
		<h4>帳單明細</h4>
			
	</div>
	
	
	<el-form :model="ruleForm"  label-width="100px"  label-position="top" size="mini" disabled >
		<el-row :gutter="20">
			 <el-col :span="12">
	  <el-form-item label="名字" prop="first_name">
	    <el-input v-model="ruleForm.first_name"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="姓" prop="last_name">
	    <el-input v-model="ruleForm.last_name"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	
	 
	 <el-row :gutter="20">
	 			 <el-col :span="12">
	  <el-form-item label="電話" prop="phone">
	    <el-input v-model="ruleForm.phone"></el-input>
	  </el-form-item>
	  </el-col>
	  <el-col :span="12">
	  <el-form-item label="昵稱" prop="nickname" >
	    <el-input v-model="ruleForm.nickname"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 
	 
	 <el-row :gutter="20">
	 			 <el-col :span="24">
	  <el-form-item label="國家/地區" prop="country">
	    <el-input v-model="ruleForm.country"></el-input>
	  </el-form-item>
	  </el-col>

	 </el-row>
	 <el-row :gutter="20">
	 		
	  <el-col :span="24">
	  <el-form-item label="ID" prop="identity_id">
	    <el-input v-model="ruleForm.identity_id" placeholder="大陸和臺灣必須填寫身份證號碼"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 			 <el-col :span="24" >
	  <el-form-item label="地址行" prop="address_line">
	    <el-input v-model="ruleForm.address_line"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>

	 <el-row :gutter="20">
	 	 <el-col :span="24">
	  <el-form-item label="省" prop="province">
	    <el-input v-model="ruleForm.province"></el-input>
	  </el-form-item>
	  </el-col>
	
	  </el-col>
	 </el-row>
	 <el-row :gutter="20">
	 
	  <el-col :span="24">
	  <el-form-item label="城鎮/都市" prop="city">
	    <el-input v-model="ruleForm.city"></el-input>
	  </el-form-item>
	  </el-col>
	
	 </el-row>
	 <el-row :gutter="20">

	  <el-col :span="24">
	  <el-form-item label="郵遞區號/郵遞區號" prop="postcode">
	    <el-input v-model="ruleForm.postcode"></el-input>
	  </el-form-item>
	  </el-col>
	 </el-row>
	 <el-row>
	
	  </el-row>
	 <el-row :gutter="20">
	
	 </el-row>
	 
	
	  </el-form-item>
	</el-form>
	


	</div>
	<div class="login-r2">
		<div class="re-tit">
			<h4>您的訂單</h4>
			
			
		</div>
	
		<div class="ord-cart" >
				<div class="cart-tit">
					<h4>產品</h4><h4>小計</h4>
					
							</div>
							<div class="cart-con">
								<ul>
									<li v-for="item in list">
										<div class="lt">
										<div class="pic">
											<img :src="item.image" />
										</div>
										<div class="txt">
											<p>{{item.title}}</p><p>{{item.num}}×{{item.price_sale}}積分</p>
										</div>
										</div>
									
									</li>
							</ul>
							</div>
							<div class="cart-bot">
								
								<div class="l1">
									<h4>運費</h4>
									<h4>CN ¥ {{buff.yunfei||0}}</h4>
								</div>
								<div class="l3">
									<h4>總計</h4>
									<h4>CN ¥ {{buff.yunfei||0}}</h4>
								
								</div>
							
							</div>
								
				   
		</div>
		
		<div class="ord-cart" >
			<!-- <div class="ord-cir">
		
			<img class="p1" src="../../assets/fid.png" />	PAYPAL <img class="p2" src="../../assets/paypal.png" />
			</div> -->
		
					
					<div class="ord-cir" @click="type=2">
							
					<img v-if="type==2" class="p1" src="../../assets/fid.png" /><img v-else class="p1" src="../../assets/fid2.png" />微信支付 <img class="p2" src="../../assets/wech.png" />
					</div>
						<div class="ord-cir" @click="type=3">
							
						<img v-if="type==3" class="p1" src="../../assets/fid.png" /><img v-else class="p1" src="../../assets/fid2.png" />	ALIPAY <img class="p2" src="../../assets/alipay1.png" />
						</div>		
				   
		</div>
		<div class="h-button" @click="sandBlue">下單</div>

	</div>
<!-- <div class="h-button" @click="sandBlue">下單</div> -->

	<div class="clear"></div>

	
</div>
   </div>

    </div>
</template>
<script>


export default {

  data() {
    return {
		id:'',
		news:'',
		page:1,
		pagenum:100,
		address_id:'',
		roll:'',
		price:0,
		buff:'',
		type:2,
		list:[],
		product_info:[],
		form:{
			korean_code:'',
			remark:''
		},
           ruleForm: {
           	first_name:'',
           	last_name:'',
                    
           	phone:'',
           	nickname:'',
           	country:'',
           	identity_id:'',
           	address_line:'',
           	province:'',
           	city:'',
           	postcode:'',
           			moren: 0,
                     
               
                 },
                  rules: {
					
					  email: [
					    { required: true, message: 'Please fill in email', trigger: 'blur' },
				],password: [
					    { required: true, message: 'Please fill in password', trigger: 'blur' },
				]
                 
                  },product_info:[]
          };
  },  mounted() {
	
	   
	  this.id = this.$route.query.id
 this.list =JSON.parse(window.localStorage.getItem('order_info'))
 this.product_info=JSON.parse(window.localStorage.getItem('product_info'))
		this.sandMate();
		this.sandCart()
	//this.sandCase()
	
		},methods: {
			sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
					
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							this.product_info.push({
									"inventoryId": item.inventoryId,
									"productId": item.productId,
									"num": item.num
								})
							//	this.sandCase();
							
						})
						
					}
				 
				});
			},
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailLogin",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
						localStorage.setItem("user", JSON.stringify(data.data));
			
		     this.$alert(data.message, '提示', {
		              confirmButtonText: '确定',
		              callback: action => {
		              this.$router.push({ path: "/" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  ordCase(item){
				this.address_id=item.id  
				this.sandRill()
				this.sandCase()
			  },
			  sandRill(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_detail",
			  	  data: {id:this.address_id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  					
			  			this.ruleForm=data.data;
			  		
			  		}
			  	 
			  	});
			  
			  },
			  sandRed(id){
				  if(this.type==2){
				  					   this.$router.push({ path: "/product/pay?id="+id });	 
				  }else{
				  					  this.$router.push({ path: "/product/pays?id="+id });	 
				  }
			 //  	this.$axios({
			 //  	  method: "post",
			 //  	  url: "service.php?action=paypal_pay",
			 //  	  data: {order_id:id},  
			 //  	}).then((res) => {
			 //  		let data=res.data;
			  
			 //  		if(data.code==1){
			 //  			window.location.href=data.data.link	
				
			 //  		}
			  	 
			 //  	});
			  
			  },
			  sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_getPayInfo",
			  	  data: {product_info:JSON.stringify(this.product_info),address_id:this.address_id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  					
			  			this.buff=data.data;
			  		
			  		}else{
						this.$message.error(data.message);
					}
			  	 
			  	});
			  
			  },
			  sandBlue(){
				  if(this.address_id==''){
					  this.$message.error("请选择收货地址");
					  return
				  }
			  
			  this.$axios({
			    method: "post",
			    url: "service.php?action=money_jifenOrder",
			    data: {inventoryId:this.id,num:1,address_id:this.address_id},  
			  }).then((res) => {
			  	let data=res.data;
			  	
			  	if(data.code==1){
			  		this.$message.success(data.message);
					this.sandRed(data.order_id)
			  	// this.$router.push({ path: "/user/gift"});	
			  	
			  	}else{
			  		this.$message.error(data.message);
			  	}
			   
			  });
			  
			  
			  
			  },
			  sandMate(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_lists",
			  	  data: {page:this.page,pagenum:this.pagenum},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  	
			  							
			  			this.news=data.data;
			  			
			  			
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
		
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	float: left;
	padding-right: 50px;
}
.login-r2{
	width:530px;
background-color: #F8F8F8;
	padding: 50px;
	float: left;

}
.address{
	.re-con{
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.ord-cook{
			background: url(../../assets/up.png) no-repeat right bottom;
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}
	.ord-cart{
		margin-bottom: 20px;
		background: #FFFFFF;
	
		border: 1px solid #eeeeee;
		.cart-tit{
			height:70px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 20px;
			border-bottom: 1px solid #eeeeee;
			img{
				width: 11px;
				height: 10px;
			}
			h4{
			
				font-size: 16px;
				font-family: Arial;
				font-weight: bold;
				color: #2D2A2A;
					
			}
		}
		.cart-but{
			margin-top: 20px;
		}
		.cart-con{
		
			li{
				padding: 20px;
				display: flex;
				border-bottom: 1px solid #eeeeee;
				justify-content: space-between;
				.pic{
					width: 115px;
					height: 77px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.txt{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					margin-left: 10px;
					
				}
				.lt{
					display: flex;
				}
				
				
			}
		}
		.cart-bot{
		
			padding: 20px;
			border-top: 1px solid #eeeeee;
			.l1{
				display: flex;
				line-height: 50px;
				justify-content: space-between;
				border-bottom: 1px solid #eeeeee;
				
				font-size: 14px;
				font-family: Arial;
				font-weight: bold;
				color: #2D2A2A;
			}
			.l3{
				font-size: 24px;
				display: flex;
				line-height: 50px;
				justify-content: space-between;
			
			}
		}
		.ord-cir{
			display: flex;
			padding: 20px;
			line-height: 50px;
			align-items: center;
			.p1{
				width: 13px;
				height: 13px;
				margin-right: 10px;
			}
			.p2{
				
				margin-left: 10px;
			}
		}
	}
</style>